// R-2026-09-21: logout/401/2FA 时 localStorage 清理的白名单。
// 全局偏好(theme/language/i18nextLng)和 per-user 偏好(下次不再显示、KPI 隐藏、列宽、权重等)
// 都需要保留 — 否则用户每次退出登录都"回到默认",违反用户预期。
//
// 为什么不用 startsWith('pmwork_'):一些 UI key 不带 pmwork 前缀
// (dashboard.info_collapsed / schedule.task_columns / sidebarCollapsed /
//  gantt_name_col_width / gantt-scroll-position / weights_*) — 显式列出更稳。
//
// 跨账号安全:保留的 key 都带 userId 后缀(:${uid})或本身 per-user 隔离
// (pmwork_kpiRowHiddenPages_${uid} / pmwork_onboarding_done_${uid}),
// 不同账号不会互相污染。

const EXACT_PRESERVE = new Set([
  'theme',
  'language',
  'i18nextLng',
  // R-fix-2026-10-21:用户要求「退出后重新登录,仍选中上次退出的项目」。
  // 不在白名单 → logout 清理循环会把它删掉,重登只能走 projects[0]。
  'currentProjectId',
])

const PREFIX_PRESERVE = [
  'pmwork_onboarding_done_',     // Onboarding「下次不再显示」(per-user)
  'pmwork_kpiRowHiddenPages_',   // 11 页首行统计卡片显示/隐藏(per-user)
  // R-fix-2026-10-21:用户要求「退出后重新登录,仍选中上次退出的项目」。
  // currentProjectId 是全局单值 key(不带 userId 后缀),本来会被 logout 清掉,
  // 导致重登走 projects[0];pmwork_last_visited_${uid} 是 per-user 的,同样被清。
  // 两个都保留 → 重登时 App.jsx:397 的兜底链能恢复上次选择。
  // 跨账号安全:App.jsx:659 有 useEffect 在 user.id 变化时校验
  // currentProjectId 是否属于新用户可见项目,越权会重置,不会数据泄漏。
  'pmwork_last_visited_',
  'pmwork_current_project_',  // per-user 当前项目(R-fix-2026-10-21 数据隔离)
  'dashboard.info_collapsed:',   // Dashboard 项目信息折叠(per-user)
  'schedule.task_columns:',      // Schedule 列可见性(per-user)
  'sidebarCollapsed:',           // 侧边栏折叠(per-user)
  'gantt_name_col_width:',       // Gantt 任务名列宽(per-user)
  'gantt-scroll-position:',      // Gantt 滚动位置(per-user + per-project)
  // R-fix-2026-10-22:甘特图工具栏开关/行高 —— useUserLocalStorage 会加 :${userId} 后缀,
  // 但 logout 的清理循环是 startsWith 前缀匹配,不加进白名单就会被清掉
  // (进度前锋线开关、隐藏已完成开关、甘特图行高 —— 退出后本来就不该重置)。
  'gantt_show_front_line',      // 进度前锋线开关(per-user)
  'gantt_hide_completed',       // 隐藏已完成任务开关(per-user)
  'gantt_row_height',           // 甘特图行高 px(per-user)
  'gantt_row_height_density',   // 甘特图行高档位(per-user)
  'table_row_height',           // 列表行高 px(per-user)
  'weights_',                    // WeightModal 任务权重(per-user + per-project)
]

export function shouldPreserveKey(key) {
  if (!key) return false
  if (EXACT_PRESERVE.has(key)) return true
  return PREFIX_PRESERVE.some(prefix => key.startsWith(prefix))
}